import React from "react";
import { Box, CircularProgress } from "@mui/material";
import { useAppContext } from '../../context/AppContext';

/**
 * LoadingOverlay
 * --------------
 * Props
 * • open (boolean) – show / hide the overlay.
 * • opacity (number) – (optional) background dim (0 – 1). Default 0.6.
 * • blur (number) – (optional) px of backdrop blur. Default 4.
 * • zIndex (number) – (optional) place above UI. Default 1300 (above MUI Modal).
 */
const LoadingOverlay = ({ open, opacity = 0.6, blur = 2, zIndex = 9999, }) => {
    const { appColors } = useAppContext();
    
    if (!open) return null;

    return (
        <Box
            sx={{
                position: "fixed",
                inset: 0,
                bgcolor: `rgba(255,255,255,${opacity})`,
                backdropFilter: `blur(${blur}px)`,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                zIndex,
                pointerEvents: "auto", // block clicks beneath
            }}
        >
            <CircularProgress size={70} sx={{ color: appColors.secondary }} />
        </Box>
    );
};

export default LoadingOverlay;
